/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Limits_Desc6Inputs */

const en_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per-key limits and usage metering so one agent cannot burn your budget.`)
};

const ar_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدود وقياس استخدام لكل مفتاح حتى لا يحرق أي وكيل ميزانيتك.`)
};

const bn_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতি-কী লিমিট আর ব্যবহার পরিমাপ, যাতে কোনো এজেন্ট আপনার বাজেট পুড়িয়ে না দেয়।`)
};

const de_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limits und Verbrauchsmessung pro Schlüssel, damit kein Agent Ihr Budget verbrennt.`)
};

const es_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites y medición de uso por clave para que ningún agente queme su presupuesto.`)
};

const fr_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites et mesure d'usage par clé pour qu'aucun agent ne brûle votre budget.`)
};

const pt_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites e medição de uso por chave para nenhum agente queimar o seu orçamento.`)
};

const zh_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 key 限流和用量计量，不让任何助手烧掉你的预算。`)
};

const tr_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtar başına limit ve kullanım ölçümü, hiçbir ajan bütçenizi yakamaz.`)
};

const ru_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лимиты и учёт использования на ключ, чтобы ни один агент не сжёг ваш бюджет.`)
};

const pl_svc_mcp_server_development_limits_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limity i pomiar zużycia na klucz, by żaden agent nie spalił budżetu.`)
};

/**
* | output |
* | --- |
* | "Per-key limits and usage metering so one agent cannot burn your budget." |
*
* @param {Svc_Mcp_Server_Development_Limits_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_limits_desc6 = /** @type {((inputs?: Svc_Mcp_Server_Development_Limits_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Limits_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "de") return de_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "es") return es_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_limits_desc6(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_limits_desc6(inputs)
	return en_svc_mcp_server_development_limits_desc6(inputs)
});
export { svc_mcp_server_development_limits_desc6 as "svc_mcp-server-development_LIMITS_desc" }